// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`IP Disable Button Component should match snapshot 1`] = `
<Popconfirm
  cancelText="No"
  className="disableIpAddress"
  closeOnOutsideClick={true}
  okText="Yes"
  okType="danger"
  onConfirm={[Function]}
  title={
    <div
      style={
        {
          "width": "350px",
        }
      }
    >
      <p
        style={
          {
            "marginBottom": "0px",
          }
        }
      >
        Are you sure you want to disable this IP address? 
      </p>
      <p
        style={
          {
            "marginBottom": "5px",
            "marginTop": "0px",
          }
        }
      >
        Note: It will be permanently disabled.
      </p>
    </div>
  }
>
  <Button
    disabled={true}
    size="small"
    type="danger"
  >
    Disable
  </Button>
</Popconfirm>
`;
